import { useNavigate, useParams } from 'react-router-dom';
import userSix from '../../images/user/maths.png';
import { useAuth } from '../../utils/Auth/AuthProvider';
import { useStudentProfile, useStudentResults } from '../../react-query/queries';
import { Disclosure } from '@headlessui/react'
import StudentExamTaken from './StudentExamTaken';
import { useState } from 'react';

const navigation = [
    { name: 'Exams Taken', href: '#', current: true },
    { name: 'Chapter Statistics', href: '#', current: false },
    { name: 'Subject Statistics', href: '#', current: false },
]

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

function StudentProfileCard() {
    const { token } = useAuth();
    const navigate = useNavigate();
    const { studId } = useParams();
    const [resultId, setResultId] = useState<number>();

    const { status: studentStatus, data: studentData, error: studentError, isFetching: studentIsFetching } = useStudentProfile(token, studId)




    return (
        <div className="grid grid-cols-12 gap-5">
            <div className="col-span-3">
                <div className="w-full bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
                    <div className="max-w-full overflow-x-auto">
                        <h4 className="mb-6 text-xl font-semibold text-black dark:text-white">
                            Profile
                        </h4>
                    </div>
                    <div className="relative border-b border-stroke px-4 py-4 dark:border-strokedark">
                        <img src={userSix} className='rounded-full' alt="profile" />
                        <div className="my-5.5 text-center">
                            <h4 className="mb-0.5 text-2xl font-bold text-black dark:text-white">
                                {studentData != null ? studentData['name'] : ''}
                            </h4>
                            <p className="text-lg font-medium">{studentData != null ? `Grade ${studentData['grade']}` : ''}</p>
                        </div>

                    </div>
                    <br />
                    <div className="flex">
                        <div className="mr-4.5 content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 fill-current">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                            </svg>
                        </div>
                        <div className='content-center'>
                            <h5 className="font-medium text-black dark:text-white">
                                Phone #
                            </h5>
                            <p className="text-sm font-medium"> {studentData != null ? studentData['phone'] : ''}</p>
                        </div>
                    </div>
                    <br />
                    <div className="flex">
                        <div className="mr-4.5 h-13 content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 fill-current">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                            </svg>

                        </div>
                        <div className='content-center'>
                            <h5 className="font-medium text-black dark:text-white">
                                Created on
                            </h5>
                            <p className="text-sm font-medium"> {studentData != null ? studentData['created'] : ''}</p>
                        </div>
                    </div>

                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
            <div className="col-span-9">
                <Disclosure as="nav" className="bg-gray-800">
                    <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                        <div className="relative flex h-16 items-center justify-between">

                            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">

                                <div className="hidden sm:ml-6 sm:block">
                                    <div className="flex space-x-4">
                                        {navigation.map((item) => (
                                            <a
                                                key={item.name}
                                                href={item.href}
                                                aria-current={item.current ? 'page' : undefined}
                                                className={classNames(
                                                    item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                                    'rounded-md px-3 py-2 text-sm font-medium',
                                                )}
                                            >
                                                {item.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                </Disclosure><br />

                <StudentExamTaken />

            </div>
        </div>
    )
}

export default StudentProfileCard